const pageNameKey = "renderOnlyForDevelopersInfo";

export const renderOnlyForDevelopersInfoEn = {
  [pageNameKey]: {
    toolTipText:
      "Developer features are features that are only available to developers. (Click to toggle border)",
    infoText: "Render developer features",
  },
};

export const renderOnlyForDevelopersInfoPtBr = {
  [pageNameKey]: {
    toolTipText:
      "Recursos de desenvolvedor são recursos que estão disponíveis apenas para desenvolvedores. (Clique para alternar a borda)",
    infoText: "Renderizar recursos do desenvolvedor",
  },
};

export const renderOnlyForDevelopersInfoDe = {
  [pageNameKey]: {
    toolTipText:
      "Entwicklerfunktionen sind Funktionen, die nur für Entwickler verfügbar sind. (Klicken, um den Rand umzuschalten)",
    infoText: "Entwicklerfunktionen darstellen",
  },
};

export const renderOnlyForDevelopersInfoZhHans = {
  [pageNameKey]: {
    toolTipText: "开发者功能是仅供开发者使用的功能。（点击切换边框）",
    infoText: "渲染开发者功能",
  },
};

export const renderOnlyForDevelopersInfoIt = {
  [pageNameKey]: {
    toolTipText:
      "Disponibile solo agli sviluppatori. (Clicca per attivare/disattivare il bordo)",
    infoText: "Visualizza le funzionalità per sviluppatori",
  },
};

export const renderOnlyForDevelopersInfoEs = {
  [pageNameKey]: {
    toolTipText:
      "Las funciones para desarrolladores son funciones que solo están disponibles para desarrolladores. (Haz clic para alternar el borde)",
    infoText: "Renderizar funciones para desarrolladores",
  },
};

export const renderOnlyForDevelopersInfoNl = {
  [pageNameKey]: {
    infoText: "Ontwikkelaarsfuncties weergeven",
    toolTipText:
      "Ontwikkelaarsfuncties zijn functies die alleen beschikbaar zijn voor ontwikkelaars. (Klik om de rand weer te geven/verbergen)",
  },
};

export const renderOnlyForDevelopersInfoTr = {
  [pageNameKey]: {
    infoText: "Render geliştirici özellikleri",
    toolTipText:
      "Geliştirici özellikleri yalnızca geliştiricilerin kullanımına sunulan özelliklerdir. (Sınırları değiştirmek için tıklayın)",
  },
};
